import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	cloneDeep
} from 'lodash';

import moment from 'moment';
import toastr from '@/support/toastr';

import {
	EventBus
} from '@/support/event-bus';

export default {
	name: 'medicine-pending',
	data: () => ({
		pendingList: {
			list: []
		}
	}),
	computed: {
		...mapGetters({
			getLoggedUser: 'getLoggedUser',
			medicineDate: 'medicineDate',
			medicinePending: 'medicinePending'
		})
	},
	methods: {
		...mapActions([
			'saveMedicineTaken',
			'setRejectMedicine',
			'setRejectionReasonMedicine'
		]),
		saveMedicineHour(id, takenHour) {

			if (this.getTimeDiff(takenHour) > 0) {

				this.saveMedicineTaken({
					id: id,
					userId: this.getLoggedUser.id,
					time: takenHour.length === 5 ? takenHour + ':00' : takenHour
				}).then(() => {
					EventBus.$emit('medicineListChange');
					toastr.success('Medicação ministrada com sucesso!');
				});

			} else if (this.getTimeDiff(takenHour) <= 0) {
				toastr.warning('O horário da medicação não pode ser uma data futura.');
			} else {
				toastr.warning('Por favor, verifique o horário da medicação.');
			}
		},
		setReject(index) {

			this.setRejectMedicine(index);
			this.pendingList = cloneDeep(this.medicinePending);

		},
		rejectionMedicine(id, reason, index) {

			this.setRejectionReasonMedicine({
				id: id,
				userId: this.getLoggedUser.id,
				rejectionReason: reason
			}).then(() => {

				this.pendingList.list.splice(index, 1);
				EventBus.$emit('medicineListChange');
				toastr.success('Medicação rejeitada com sucesso!');

			});

		},
		getTimeDiff(time) {

			if (time) {

				const [year, month, date] = this.medicineDate.split('-');
				const [hour, minute] = time.split(':');

				return moment().diff(
					moment().set({
						year,
						month: (month - 1),
						date,
						hour,
						minute,
						second: 0
					})
				);

			}

		},
		getTakenHourInputName(index) {
			return `medicine-takenHour-${ index }`;
		},
		isBeforeDate() {
			return (moment().diff(this.medicineDate, 'days') > 0);
		}
	},
	mounted() {

		this.pendingList = this.medicinePending;

	}
};



// WEBPACK FOOTER //
// ./sources/domains/medicine/medicine-pending/index.js